import { useSearchParams } from "react-router-dom"
import LoginByCode from "./login-by-code"
import LoginByToken from "./login-by-token"
import TraditionalLogin from "./traditional-login"
import AccessDeniedError from "./access-denied-error"

export default function Login() {
  const [searchParams] = useSearchParams()

  const token = searchParams.get("token")
  const redirect = searchParams.get("redirect")
  const code = searchParams.get("code")
  const error = searchParams.get("error")

  const isLoginThroughToken =
    token && token.trim().length > 0 && redirect && redirect.trim().length > 0

  const isLoginThroughCode = code && code.trim().length > 0
  const isAccessDeniedError = error && error === "access_denied"

  if (isAccessDeniedError) {
    return <AccessDeniedError />
  }

  if (isLoginThroughCode) {
    return <LoginByCode code={code} />
  }

  if (isLoginThroughToken) {
    return <LoginByToken token={token} redirect={redirect} />
  }

  return <TraditionalLogin />
}
